import React from 'react';
import { Button } from '../ui/button';
import { Eye, Pencil } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

/**
 * RBAC-aware row actions. Renders a single action based on the user's rights
 * for `doctype` (mirrors backend rbac_crud.has_permission via AuthContext.canWrite):
 *   - write/create access -> Edit (editing includes viewing)
 *   - read-only           -> View (read-only)
 * No delete action by design.
 *
 * Props:
 *   doctype  : string  - RBAC doctype this record belongs to
 *   onView   : fn      - open read-only view
 *   onEdit   : fn      - open edit form
 *   idForTestId : string (optional) - suffix for data-testid uniqueness
 *   size     : button size (default 'sm')
 */
export const RecordActions = ({ doctype, onView, onEdit, idForTestId = '', size = 'sm', className = '' }) => {
  const { canWrite } = useAuth();
  const writable = canWrite(doctype);
  const suffix = idForTestId ? `-${idForTestId}` : '';

  if (writable) {
    return (
      <Button
        size={size}
        variant="outline"
        onClick={onEdit}
        title="Edit"
        data-testid={`btn-edit${suffix}`}
        className={className}
      >
        <Pencil className="w-4 h-4" />
      </Button>
    );
  }
  return (
    <Button
      size={size}
      variant="outline"
      onClick={onView}
      title="View"
      data-testid={`btn-view${suffix}`}
      className={className}
    >
      <Eye className="w-4 h-4" />
    </Button>
  );
};

export default RecordActions;
